import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { searchUsersSuccess, searchUsersFailure } from "../../Action/auth/searchUsersAction";
import { SEARCH_USERS } from "../../Action/actionTypes";

function* searchUsersRequest(action) {
  try {
    const { searchQuery, whiteLabelID } = action?.payload?.payload;
    
    // Build query string with optional whiteLabelID
    let queryString = `/getuserslist?search=${searchQuery}&roleFilter=users&roleType=7`;
    if (whiteLabelID) {
      queryString += `&whiteLabelID=${whiteLabelID}`;
    }
    
    const { data } = yield API.get(queryString);

    if (data?.meta?.code === 200) {
      yield put(searchUsersSuccess(data?.data?.users || []));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(searchUsersFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(searchUsersFailure());
  }
}

export function* watchSearchUsersAPI() {
  yield takeEvery(SEARCH_USERS, searchUsersRequest);
}

export default function* rootSaga() {
  yield all([watchSearchUsersAPI()]);
}
